import { createApi } from "@reduxjs/toolkit/query/react";

import apiBaseQuery from "./axiosBaseQuery";
import supplierBaseQuery from "./supplierBaseQuery";

export const USERS_API_REDUCER_KEY = "usersApi";

export const usersApi = createApi({
  reducerPath: USERS_API_REDUCER_KEY,
  baseQuery: supplierBaseQuery,
  tagTypes: ["user"],
  endpoints: (builder) => ({
    // getMe: builder.query({
    //   query: () => ({
    //     url: "/admin/supplier/users/me/",
    //   }),
    //   providesTags: ["user"],
    // }),

    getUsers: builder.query({
      query: ({ supplier_id }) => ({
        url: `/suppliers/${supplier_id}/users/`,
      }),
      providesTags: ["user"],
    }),

    getUser: builder.query({
      query: ({ id, supplier_id }) => {
        if (!id || !supplier_id) {
          return;
        }
        return {
          url: `/suppliers/${supplier_id}/users/${id}`,
        };
      },
      providesTags: ["user"],
    }),

    createUser: builder.mutation({
      query: ({ supplier_id, body }) => {
        return {
          url: `/suppliers/${supplier_id}/users/`,
          method: "POST",
          body,
        };
      },
      invalidatesTags: ["user"],
    }),
    updateUser: builder.mutation({
      query: ({ supplier_id, id, body }) => {
        return {
          url: `/suppliers/${supplier_id}/users/${id}`,
          method: "PUT",
          body: body,
        };
      },
      invalidatesTags: ["user"],
    }),
    deleteUser: builder.mutation({
      query: ({ id, supplier_id }) => {
        return {
          url: `/suppliers/${supplier_id}/users/${id}`,
          method: "DELETE",
        };
      },
      invalidatesTags: ["user"],
    }),
    // forgotPassword: builder.mutation({
    //   query: (body) => {
    //     return {
    //       url: `/admin/users/email-reset/`,
    //       method: "POST",
    //       body,
    //     };
    //   },
    //   invalidatesTags: ["user"],
    // }),
    // resetPassword: builder.mutation({
    //   query: (body) => {
    //     return {
    //       url: `/admin/users/reset-password`,
    //       method: "POST",
    //       body,
    //     };
    //   },
    //   invalidatesTags: ["user"],
    // }),
  }),
});

export const {
  useCreateUserMutation,
  // useGetMeQuery,
  useGetUserQuery,
  useGetUsersQuery,
  useUpdateUserMutation,
  useDeleteUserMutation,
  // useLazyGetMeQuery,
} = usersApi;
